<template>
  <el-tabs v-model="activeName" type="border-card" style="width: 100%;">
    <el-tab-pane label="帮助中心列表" name="first">
      <div class="main">
        <!-- Right -->
        <div class="main_r">
          <!-- search -->
          <div class="search">
            <div>
              <el-input v-model="queryData.question"  placeholder="请输入问题"></el-input>
              <el-input v-model="queryData.answer"  placeholder="请输入回答"></el-input>
              <el-select v-model="queryData.category" placeholder="请选择分类">
                <el-option label="全部" value=""></el-option>
                <el-option label="硬件相关" value="hardware"></el-option>
                <el-option label="软件相关" value="software"></el-option>
                <el-option label="配件相关" value="accessory"></el-option>
              </el-select>
              <el-date-picker v-model="queryData.timeBegin" type="date" value-format="yyyy-MM-dd" placeholder="起始时间" class="mr15"></el-date-picker>
              <el-date-picker v-model="queryData.timeEnd" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
              <el-button type="primary" @click="clickQuery">查询</el-button>
              <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
              <el-button type="primary" @click="clickdialogAdd">新增</el-button>
            </div>
          </div>
          <!-- search End -->

          <!-- 列表 -->
          <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" @sort-change="handleSortChange">
            <el-table-column prop="id" label="序号" width="80" sortable="custom"></el-table-column>
            <el-table-column prop="question" label="问题" sortable="custom"></el-table-column>
            <el-table-column prop="answer" label="回答" sortable="custom"></el-table-column>
            <el-table-column prop="cover" label="封面" width="100">
              <template slot-scope="scope">
                <el-image 
                  v-if="scope.row.cover"
                  style="width: 50px; height: 50px"
                  :src="getImageUrl(scope.row.cover)" 
                  :preview-src-list="[getImageUrl(scope.row.cover)]"
                  fit="cover">
                </el-image>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="category" label="分类" width="100" sortable="custom">
              <template slot-scope="scope">
                <span v-if="scope.row.category === 'hardware'">硬件相关</span>
                <span v-else-if="scope.row.category === 'software'">软件相关</span>
                <span v-else-if="scope.row.category === 'accessory'">配件相关</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" sortable="custom"></el-table-column>
            <el-table-column label="英文问题" min-width="120">
              <template slot-scope="scope">
                <span>{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['en'] && translationMap[scope.row.id]['en']['question']) || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="德文问题" min-width="120">
              <template slot-scope="scope">
                <span>{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['de'] && translationMap[scope.row.id]['de']['question']) || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="Operation" label="操作" width="150">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="编辑" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-edit" class="mr12" @click="clickdialogEdit(scope.row)"></el-link>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                  <el-link :underline="false" type="danger" icon="el-icon-delete" class="mr12" @click="ClickDelete(scope.row)"></el-link>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="翻译" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-s-opportunity" class="mr12" @click="clickI18n(scope.row)"></el-link>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="mt20">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page_no"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="page_size"
              layout="prev, pager, next, sizes, jumper "
              :total="dataListnum">
            </el-pagination>
          </div>
          <!-- 分页 End -->
        </div>
        <!-- Right End -->

        <!---------------------- 以下是弹框内容 ---------------------->
        <!-- 新增用户 -->
        <el-dialog title="添加帮助" :visible.sync="dialogAdd" width="40%" class="newAdd" :close-on-click-modal="false">
          <div class="addUser_body">
            <el-form ref="userMsg" :model="addData" label-width="80px">
              <el-form-item label="问题" :required=true>
                <el-input v-model="addData.question" placeholder="请输入问题"></el-input>
              </el-form-item>
              <el-form-item label="回答" :required=true>
                <el-input type="textarea" :rows="4" v-model="addData.answer" placeholder="请输入回答"></el-input>
              </el-form-item>
              <el-form-item label="分类" :required=true>
                <el-select v-model="addData.category" placeholder="请选择分类" style="width: 100%">
                  <el-option label="硬件相关" value="hardware"></el-option>
                  <el-option label="软件相关" value="software"></el-option>
                  <el-option label="配件相关" value="accessory"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="封面图片">
                <el-upload
                  class="cover-uploader"
                  :action="''"
                  :http-request="handleAddUpload"
                  :show-file-list="false"
                  :before-upload="beforeImageUpload"
                  :auto-upload="true">
                  <img v-if="addData.cover" :src="getImageUrl(addData.cover)" class="cover-image">
                  <i v-else class="el-icon-plus cover-uploader-icon"></i>
                </el-upload>
                <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="HelpCenterInsert()" >确 认</el-button>
            <el-button @click="dialogAdd = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 新增用户 End -->

        <!-- 编辑信息 -->
        <el-dialog title="编辑信息" :visible.sync="dialogEdit" width="40%" class="newAdd" :close-on-click-modal="false">
          <div class="addUser_body">
            <el-form ref="userMsg" :model="editData" label-width="80px">
              <el-form-item label="问题" :required=true>
                <el-input v-model="editData.question" placeholder="请输入问题"></el-input>
              </el-form-item>
              <el-form-item label="回答" :required=true>
                <el-input type="textarea" :rows="4" v-model="editData.answer" placeholder="请输入回答"></el-input>
              </el-form-item>
              <el-form-item label="分类" :required=true>
                <el-select v-model="editData.category" placeholder="请选择分类" style="width: 100%">
                  <el-option label="硬件相关" value="hardware"></el-option>
                  <el-option label="软件相关" value="software"></el-option>
                  <el-option label="配件相关" value="accessory"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="封面图片">
                <el-upload
                  class="cover-uploader"
                  :action="''"
                  :http-request="handleEditUpload"
                  :show-file-list="false"
                  :before-upload="beforeImageUpload"
                  :auto-upload="true">
                  <img v-if="editData.cover" :src="getImageUrl(editData.cover)" class="cover-image">
                  <i v-else class="el-icon-plus cover-uploader-icon"></i>
                </el-upload>
                <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="HelpCenterUpdate()" >确 认</el-button>
            <el-button @click="dialogEdit = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 编辑信息 End -->

        <!-- 删除 -->
        <el-dialog title="操作确认" :visible.sync="dialogDel" width="20%" class="confirmDel" :close-on-click-modal="false">
          <div class="confirmMsg">确定删除？</div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="HelpCenterDelete" >确 定</el-button>
            <el-button @click="dialogDel = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 删除 End -->

        <!-- 翻译管理 -->
        <i18n-translation-dialog
          :visible.sync="dialogI18n"
          :entity-type="i18nEntityType"
          :entity-id="i18nEntityId"
          :fields="i18nFields">
        </i18n-translation-dialog>

      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import I18nTranslationDialog from '@/components/I18nTranslationDialog.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    I18nTranslationDialog
  },
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      queryData: {
        question: '',
        answer: '',
        category: '',
        timeBegin: '',
        timeEnd: ''
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 5,
      sortField: '',
      sortOrder: '',
      // 新增
      dialogAdd: false,
      addData: {
        question: '',
        answer: '',
        cover: '',
        category: ''
      },
      uploadAction: Vue.prototype.global.Url_Base + 'Upload/file',
      // 编辑
      dialogEdit: false,
      editData: {
        id: '',
        question: '',
        answer: '',
        cover: '',
        category: ''
      },
      // 删除
      deleteForm: {
        id: ''
      },
      dialogDel: false,
      // 翻译管理
      dialogI18n: false,
      i18nEntityId: null,
      i18nEntityType: 'HELP_CENTER',
      i18nFields: [
        { name: 'question', label: '问题', type: 'input' },
        { name: 'answer', label: '回答', type: 'textarea' }
      ],
      translationMap: {}
    }
  },
  mounted () {
    this.HelpCenterList()
    this.HelpCenterNum()
  },
  methods: {
    handleSizeChange (val) {
      this.page_size = val
      this.HelpCenterList()
      this.HelpCenterNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.HelpCenterList()
      this.HelpCenterNum()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.HelpCenterList()
      this.HelpCenterNum()
    },
    clickQuery () {
      this.page_no = 1
      this.HelpCenterList()
      this.HelpCenterNum()
    },
    clickQueryReset () {
      this.queryData.question = ''
      this.queryData.answer = ''
      this.queryData.category = ''
      this.queryData.timeBegin = ''
      this.queryData.timeEnd = ''
      this.clickQuery()
    },
    clickdialogAdd () {
      this.dialogAdd = true
      this.addData.question = ''
      this.addData.answer = ''
      this.addData.cover = ''
      this.addData.category = ''
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData.id = row.id
      this.editData.question = row.question
      this.editData.answer = row.answer
      this.editData.cover = row.cover || ''
      this.editData.category = row.category || ''
    },
    ClickDelete (row) {
      this.dialogDel = true
      this.deleteForm.id = row.id
    },
    clickI18n (row) {
      this.i18nEntityId = row.id
      this.dialogI18n = true
    },
    HelpCenterList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.question = that.queryData.question
      data.answer = that.queryData.answer
      data.category = that.queryData.category
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_HelpCenterList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
            that.loadTranslations('HELP_CENTER', that.dataList, 'id')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    HelpCenterNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.question = that.queryData.question
      data.answer = that.queryData.answer
      data.category = that.queryData.category
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_HelpCenterNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    HelpCenterInsert: function () {
      var that = this
      if (!that.addData.question) {
        that.$message.error('请输入问题')
        return
      }
      if (!that.addData.answer) {
        that.$message.error('请输入回答')
        return
      }
      if (!that.addData.category) {
        that.$message.error('请选择分类')
        return
      }
      var data = Vue.prototype.FunGetBaseSignData()
      data.question = that.addData.question
      data.answer = that.addData.answer
      data.cover = that.addData.cover
      data.category = that.addData.category
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_HelpCenterInsert, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.HelpCenterList()
            that.HelpCenterNum()
            that.dialogAdd = false
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogAdd = false
        })
    },
    HelpCenterUpdate: function () {
      var that = this
      if (!that.editData.question) {
        that.$message.error('请输入问题')
        return
      }
      if (!that.editData.answer) {
        that.$message.error('请输入回答')
        return
      }
      if (!that.editData.category) {
        that.$message.error('请选择分类')
        return
      }
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editData.id
      data.question = that.editData.question
      data.answer = that.editData.answer
      data.cover = that.editData.cover
      data.category = that.editData.category
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_HelpCenterUpdate, Qs.stringify(data))
        .then(function (response) {
          that.dialogEdit = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.HelpCenterList()
            that.HelpCenterNum()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEdit = false
        })
    },
    HelpCenterDelete: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.deleteForm.id
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_HelpCenterDelete, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.HelpCenterList()
            that.HelpCenterNum()
          }
          that.dialogDel = false
        })
        .catch(function (error) {
          console.log(error)
          that.dialogDel = false
        })
    },
    beforeImageUpload (file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }

      return true
    },
    handleAddUpload (options) {
      var that = this
      var formData = new FormData()
      var data = Vue.prototype.FunGetBaseSignData()
      
      // 先计算签名（只包含tempUuid、timestamp、authToken）
      data.sign = Vue.prototype.FunGetSign(data)
      
      // 签名后再添加type参数（type不参与签名计算）
      data.type = 'ajax'
      
      // 添加文件
      formData.append('file', options.file)
      
      // 添加其他参数
      formData.append('tempUuid', data.tempUuid)
      formData.append('timestamp', data.timestamp)
      formData.append('type', data.type)
      formData.append('sign', data.sign)
      formData.append('category', 'images/covers/')
      
      // 使用axios手动上传
      axios.post(that.uploadAction, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        if (response.data.code === 1) {
          // 使用返回的absoluteUrl，无需手动拼接URL
          that.addData.cover = response.data.data.absoluteUrl
          that.$message.success('上传成功')
          options.onSuccess(response.data)
        } else {
          that.$message.error('上传失败：' + response.data.message)
          options.onError(response.data)
        }
      }).catch(function (error) {
        console.log(error)
        that.$message.error('上传失败！')
        options.onError(error)
      })
    },
    handleEditUpload (options) {
      var that = this
      var formData = new FormData()
      var data = Vue.prototype.FunGetBaseSignData()
      
      // 先计算签名（只包含tempUuid、timestamp、authToken）
      data.sign = Vue.prototype.FunGetSign(data)
      
      // 签名后再添加type参数（type不参与签名计算）
      data.type = 'ajax'
      
      // 添加文件
      formData.append('file', options.file)
      
      // 添加其他参数
      formData.append('tempUuid', data.tempUuid)
      formData.append('timestamp', data.timestamp)
      formData.append('type', data.type)
      formData.append('sign', data.sign)
      formData.append('category', 'images/covers/')
      
      // 使用axios手动上传
      axios.post(that.uploadAction, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        if (response.data.code === 1) {
          // 使用返回的absoluteUrl，无需手动拼接URL
          that.editData.cover = response.data.data.absoluteUrl
          that.$message.success('上传成功')
          options.onSuccess(response.data)
        } else {
          that.$message.error('上传失败：' + response.data.message)
          options.onError(response.data)
        }
      }).catch(function (error) {
        console.log(error)
        that.$message.error('上传失败！')
        options.onError(error)
      })
    },
    getImageUrl (url) {
      if (!url) return ''
      // 如果已经是完整的URL(http://或https://开头),直接返回
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url
      }
      // 兼容历史数据：如果是相对路径，拼接基础URL
      return Vue.prototype.global.Url_Base + url
    },
    loadTranslations: function (entityType, list, idField) {
      var that = this
      if (!list || list.length === 0) {
        that.translationMap = {}
        return
      }
      var ids = list.map(function(item) { return item[idField] }).join(',')
      var data = Vue.prototype.FunGetBaseSignData()
      data.entityType = entityType
      data.entityIds = ids
      data.sign = Vue.prototype.FunGetSign(data)
      axios.get(Vue.prototype.global.Url_I18nBatchList, { params: data })
        .then(function(response) {
          if (response.data.code === 1) {
            that.translationMap = response.data.data || {}
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    }
  },
  watch: {
    dialogI18n (val) {
      if (!val) {
        this.loadTranslations('HELP_CENTER', this.dataList, 'id')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 150px;
    margin-right: 15px;
  }

  .el-select{
    width: 150px;
    margin-right: 15px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}

.cover-uploader {
  /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/ .el-upload:hover {
    border-color: #409EFF;
  }
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.cover-image {
  width: 150px;
  height: 150px;
  display: block;
  object-fit: cover;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}
</style>

<style scoped>
::v-deep .el-tabs__content {
  padding: 5px;
}
</style>
